import IssueOwnershipCertificate from './IssueOwnershipCertificate'

export default IssueOwnershipCertificate
